const formatNullableBooleanAsYesNo = (value: boolean | null | undefined): string | null => {
  if (value === true) return 'Oui'
  if (value === false) return 'Non'
  return null
}

export { formatNullableBooleanAsYesNo }
